module.exports = __webpack_public_path__ + "static/Karo_2_min-d5e3f502924d0ab9e9a3f4acf801a302.jpg";